// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-R1Ex_";
var _5 = "wrapper_sticky-2BGsX";
var _6 = "inner-2bxRJ";
var _7 = "title-37PkP";
var _8 = "segments-KbrTv";
var _9 = "close-3qsCg";
var _a = "wrapper_center-21ql5";
var _b = "wrapper_withClose-2UAFl";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "wrapper_sticky", _6 as "inner", _7 as "title", _8 as "segments", _9 as "close", _a as "wrapper_center", _b as "wrapper_withClose" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "wrapper_sticky": _5, "inner": _6, "title": _7, "segments": _8, "close": _9, "wrapper_center": _a, "wrapper_withClose": _b }
